import Bugsnag from '@bugsnag/js';
import axios from '@/axios';

const collapseZiggy = (obj) => {
    if (typeof obj !== 'object') {
        return obj;
    }

    const data = Object.entries(obj).map(([key, val]) => {
        if (val && typeof val === 'object') {
            return [key, collapseZiggy({ ...val, ziggy: undefined })];
        }

        return [key, val];
    });

    return Object.fromEntries(data || []);
};

export default {
    data() {
        return {
            sessionHasExpired: false,
        };
    },
    methods: {
        bundleMetaData(response, request = {}, config = {}, message = '') {
            return {
                message,
                response: collapseZiggy(response),
                request: collapseZiggy(request),
                config: collapseZiggy(config),
            };
        },
        apiRequest(method, url, data, successCallback, errorCallback, config) {
            const successCb = (response, ...args) => {
                    if (response.data.status === 'success' && response.data.message) {
                        this.$nextTick(() => {
                            this.$notify.success({
                                title: 'Success',
                                message: response.data.message,
                                duration: 2000,
                            });
                        });
                    } else if (response.status === 419) {
                        if (this.sessionHasExpired) {
                            return;
                        }

                        this.sessionHasExpired = true;

                        confirm('This page has expired due to inactivity.\nWould you like to refresh the page?') && window.location.reload();
                    } else if (response.data.status === 'failure') {
                        if (response.data.message) {
                            this.$nextTick(() => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: response.data.message,
                                    duration: 4000,
                                });
                            });
                        } else {
                            this.$nextTick(() => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: `Something went wrong. Please contact support with this message: "Unexpected response. Response code: ${method}:${url}:${response.data.status}:${response.status}"`,
                                    duration: 0,
                                });
                            });
                            Bugsnag.notify(new Error(`Unexpected response. Response code: ${method}:${url}:${response.data.status}:${response.status}`), (event) => {
                                event.severity = 'error';
                                event.addMetadata('contextData', this.bundleMetaData(response));
                            });
                        }
                    }
                    if (typeof successCallback === 'function') {
                        successCallback(response, ...args);
                    }
                },
                errorCb = (error, ...args) => {
                    this.loadErrors(error);
                    Bugsnag.notify(
                        new Error(error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message || 'Unknown Error'),
                        (event) => {
                            event.severity = 'error';
                            event.addMetadata('contextData', this.bundleMetaData(error.response, error.request, error.config, error.message));
                        },
                    );
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$nextTick(() => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: error.response.data.message,
                                    duration: 4000,
                                });
                            });
                        } else if (!['failure'].includes(error.response.data.status)) {
                            this.$nextTick(() => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: `Something went wrong. Please contact support with this message: "Unexpected response. Response code: ${method}:${url}:${error.response.data.status}:${error.response.status}"`,
                                    duration: 0,
                                });
                            });
                        }
                    } else if (error.request) {
                        Bugsnag.notify(new Error('Network Error'), (event) => {
                            event.severity = 'error';
                            event.addMetadata('contextData', this.bundleMetaData(error.response, error.request, error.config, error.message));
                        });
                        this.$nextTick(() => {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Unable to connect to the internet. Please check your connection then refresh this page.',
                                duration: 0,
                            });
                        });
                    } else {
                        this.$nextTick(() => {
                            this.$notify.error({
                                title: 'Error',
                                message: `Something went wrong: ${error.message}`,
                                duration: 0,
                            });
                        });
                    }
                    if (typeof errorCallback === 'function') {
                        errorCallback(error, ...args);
                    }
                };

            return axios({ method, url, data, ...config }).then(successCb, errorCb);
        },
    },
};
